import { Service } from '@angular/core';
import { QuillModules } from 'ngx-quill';

@Service()
export class ConstantsService {
  DEFAULT_QUILL_CONFIG: QuillModules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
    ],
    clipboard: {
      matchVisual: false,
    },
  };
}
